
import {  useQuery } from "react-query"
import DataService from '../../../../config/DataServices'

const { getRequest} = DataService()


export const useUserHistory = ({ page, size,amountInType,searchText  }) => {
    return useQuery({
        queryKey: ["history", page, size,amountInType,searchText ],
        queryFn: () => {
            return getRequest(`user/auth/getAirdropLevelHis?page=${page}&size=${size}&amountInType=${amountInType}&search=${searchText}`)
        }
    })
}


export const useUserTopupComplete = ({ page, size }) => {
    return useQuery({
        queryKey: ["topup-history", page, size ],
        queryFn: () => {
            return getRequest(`user/auth/topupcomplete?page=${page}&size=${size}`)
        }
    })
}

export const useUserWithdrawHistory = ({ page, size,searchText  }) => {
    return useQuery({
        queryKey: ["withdraw-history", page, size,searchText ],
        queryFn: () => {
            return getRequest(`user/auth/getWithdrawHis?page=${page}&size=${size}&search=${searchText}`)
        }
    })
}

export const useMasterICOReferralIncome = ({ page, size,type , search }) => {
    return useQuery({
        queryKey: ["MasterICOReferralIncome-history", page, size,type, search ],
        queryFn: () => {
            return getRequest(`user/auth/getICOReferralIncome?page=${page}&size=${size}&type=${type}&search=${search}`)
        }
    })
}
